import axios from 'axios';
import { Config }   from './configActions';

var config = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
Config();
export const FETCH_ALUNOS_TURMA         = 'FETCH_ALUNOS_TURMA';
export const FETCH_ALUNOS_PONTUACAO     = 'FETCH_ALUNOS_PONTUACAO';
export const FETCH_PONTUACAO_ALUNOS     = 'FETCH_PONTUACAO_ALUNOS';
export const FETCH_RANKING_ALUNOS_TURMA = 'FETCH_RANKING_ALUNOS_TURMA';

export function GetRegistroAlunoTurma(tur_id) {
    const request = axios.get(`/api/usuarios/listar/turma/${tur_id}`,config);
    return{
        type    : FETCH_ALUNOS_TURMA,
        payload : request
    };	
}

export function PontuacaoAluno(use_id) {
 
    const request = axios.get(`/api/pontuacao/historico/aluno/${use_id}`,config);
    return{
        type    : FETCH_ALUNOS_PONTUACAO,
        payload : request
    };	
}

export function AlunoPontuacao(use_id,id_curso) {
 
    const request = axios.get(`/api/pontuacao/usuario/buscar/${use_id}/${id_curso}`,config);
    return{
        type    : FETCH_PONTUACAO_ALUNOS,
        payload : request
    };	
}

export function GetRankingAlunos(tur_id) {
       const request = axios.get(`/api/pontuacao/ranking/alunos/turma/${tur_id}`,config);
       return{
           type    : FETCH_RANKING_ALUNOS_TURMA,
           payload : request
       };	
}



// WEBPACK FOOTER //
// ./src/actions/usuarioAction.js